import React from 'react'
import { Box } from '@mui/material'
import { ProductPlatformFeatures } from 'components/product_platform_features/ProductPlatformFeatures'

export function SupportedPlatformFeatures({
  productId,
}: {
  productId: number
}) {
  return (
    <Box>
      <ProductPlatformFeatures productId={productId} />
    </Box>
  )
}
